<template>
        <b-container fluid>
            <!-- Transition to upload image -->
            <transition name="fade">
            <div v-if="uploadingImage" class="loading">
                <p>Uploading...</p>
            </div>
            </transition>

            <!-- Error modal -->
            <b-modal no-fade :id="'modal-error' + theBeer.id" ok-only title="Error" ok-title="OK" variant="error">
                {{modalErrMsg}}
            </b-modal>

            <!-- Inventory updated modal -->
            <b-modal no-fade :id="'modal-inventoryupdated' + theBeer.id" ok-only title="Inventory Updated" ok-title="OK">
                {{theBeer.beerName}} has been updated
            </b-modal>

            <!-- Post Offering Stop Confirmation -->
            <b-modal no-fade :id="'modal-confirmstoppostoff' + theBeer.id" title="Confirmation" ok-title="Yes, STOP" cancel-title="No, dont stop yet"
            @ok="stopThePostOffering">
                Stop the post offering?
            </b-modal>


            <!-- Modal for missing shipping info when updating a beer -->
            <b-modal no-fade size="l" :id="'modal-shippingerror' + theBeer.id" ok-only title="Missing Shipping/Delivery Info" ok-title="OK">
                Please enter shipping and delivery info for consumers before allowing consumers 
            </b-modal>
            <!----------------------------->
            <!-- Update inventory Error -->
            <!----------------------------->
            <b-modal no-fade size="l" :id="'modal-updateerror' + theBeer.id" title="Found some errors" 
            ok-title="OK" ok-only>
                <template v-slot:default="{ hide }">
                    <div >Please enter only numbers for cost, quantity, ABV, cans/case and make sure you have entered a name for the beer</div>
                </template>
            </b-modal>
            <!----------------------------->
            <!-- Consumer Cost Error -->
            <!----------------------------->
            <b-modal no-fade size="l" :id="'modal-consumercosterror' + theBeer.id" title="Found some errors" 
            ok-title="OK" ok-only>
                    <template v-slot:default="{ hide }">
                        <div >If selling to consumers, please enter cost and package size for consumers. Enter only numbers</div>
                    </template>
            </b-modal>
           
            <!----------------------------->
            <!-- Update style modal --> 
            <!----------------------------->
            <b-modal no-fade  scrollable size="l"  :id="'showStylesList' + theBeer.id"  title="Select Style" ok-title="Set Style" ok-only hide-footer>
                Select Style
                <!-- Iterate over all style -->
                <template  v-for="type in getMainBeerStylesList">
                    <b-button  v-if="type!='Other'" :key="type" class="m-md-2" variant="secondary" @click="setDrinkType(type)">
                        {{type}}
                    </b-button>
                </template>
                <!-- Other style -->
                <br>
                <b-button  class="m-md-2" variant="outline-primary" @click="setOtherDrinkType()">
                    Other
                </b-button>
                <div  v-if="otherPressed">
                    <b-col>
                        <form>
                            <label for="customtype">Enter a custom style name</label>
                            <input v-model="theBeer.customType" type="text" id="customtype"/>
                        </form>
                    </b-col>
                </div>
                <hr>
                <b-button :disabled="otherPressed&&!theBeer.customType" class="m-md-2" variant="primary" @click="beerTypeHasBeenSelected()">
                    Set Style
                </b-button>
            </b-modal>
            <!----------------------------->
            <!-- Inventory Card -->
            <!----------------------------->
            <b-container class="border border-secondary">
                    <!-- Name -->
                    <b-row>
                        <b-col>
                            <div class='breweryname' style='margin-bottom:15px; margin-top:10px'><h4>{{theBeer.brewer}}, {{theBeer.beerName}}</h4></div>   
                        </b-col>
                    </b-row>
                    <b-row>
                        <!-- Image -->
                        <b-col>
                            <form>
                                <div class="form-group" style="width:150px">
                                    <img :src="getImageSource" fluid alt="Logo image" style="width:150px">
                                </div>
                                <div class="form-group">
                                    <input :id="'image'+theBeer.id" type="file"  class="form-control-file"  @change="onLogoFileChanged"/>
                                </div>
                            </form>
                        </b-col>
                        <!-- Change beer info form group-->
                        <b-col>
                            <b-form-group>
                                <!-- Name -->
                                <b-form-group label-cols-sm="3" label-size="sm" label="Name:" label-align-sm="right" :label-for="'name'+theBeer.id">
                                    <b-form-input  size="sm" v-model="theBeer.beerName" :id="'name'+theBeer.id"></b-form-input>
                                </b-form-group>

                                <!-- Style and sub style -->
                                <!-- Drink Type -->
                                <b-form-group label-cols-sm="3" label-size="sm" label="Style:" label-align-sm="right" :label-for="'style'+theBeer.id">
                                    <div :id="'style'+theBeer.id">
                                        <strong>{{getNewBeerStyle}} </strong>
                                        <b-button variant="info" style="margin-left:20px"  v-b-modal="'showStylesList' + theBeer.id ">Change</b-button>
                                    </div>
                                </b-form-group>
                                <!-- Sub Style -->
                                <b-form-group label-cols-sm="3" label-size="sm" label="Sub Style:" label-align-sm="right" :label-for="'substyle'+theBeer.id">
                                    <b-form-input  size="sm" v-model="theBeer.subType" :id="'substyle'+theBeer.id"></b-form-input>
                                </b-form-group>

                                <!-- Distribution Method -->
                                <b-form-group  v-if="userProfile.isbrewer==1" label-cols-sm="3" label-size="sm" label="Distributor" label-align-sm="right" :label-for="'dropdown'+theBeer.id" >
                                    <b-dropdown variant="outline-dark" size="sm" :id="'dropdown'+theBeer.id" text="Select A Distribution Method">
                                        <b-dropdown-item  v-for="(deliveryAgent) in getDeliveryAgents" :key="deliveryAgent" @click="theBeer.deliveryMethod=deliveryAgent">{{deliveryAgent}}</b-dropdown-item>
                                        <b-dropdown-divider></b-dropdown-divider>
                                        <b-dropdown-item-button  v-b-modal="'modalmoremethods'+theBeer.id" >Other</b-dropdown-item-button>
                                    </b-dropdown>

                                    <!-- Modal for Other Distribution Method -->
                                    <b-modal no-fade :id= "'modalmoremethods'+theBeer.id"  title="Other delivery method" ok-only ok-title="OK"  @ok="theBeer.deliveryMethod=otherDeliveryMethod">
                                        <b-form-group class="mb-0" :label-for="'delivery'+theBeer.id">
                                            <b-form-textarea :id="'delivery'+theBeer.id" v-model="otherDeliveryMethod"> </b-form-textarea>
                                        </b-form-group>        
                                    </b-modal>
                                    <br>
                                    <div v-if="userProfile.isbrewer==1" >
                                        <strong>{{theBeer.deliveryMethod}}</strong>
                                    </div>
                                </b-form-group>
                                <!-- ABV -->
                                <b-form-group label-cols-sm="3" label-size="sm" label="ABV(%):" label-align-sm="right" :label-for="'abv'+theBeer.id">
                                    <b-form-input  size="sm"  v-model="theBeer.abv" :id="'abv'+theBeer.id"></b-form-input>
                                </b-form-group>

                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                        <!-- Description -->
                            <b-form-group label="Description" label-size="m" label-align-sm="left" :label-for="'description'+theBeer.id">
                                <b-form-textarea  size="sm" :id="'description'+theBeer.id" v-model="theBeer.description" rows="3" max-rows="6"></b-form-textarea>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <!----------------------------->
                    <!-- Post Offering Warning -->
                    <!----------------------------->
                    <b-row v-if="theBeer.ispostoffering" >
                        <b-col>
                            <h6 style="color:red"><em>CURRENTLY ON POST OFFERING</em></h6>
                            <!-- Stop a post offering already in progress -->
                            <b-button style='margin-bottom:10px; margin-left:10px' @click="showModalStopPostOff()" variant="outline-danger">Stop Post Offering</b-button>
                        </b-col>
                    </b-row>
                    <!----------------------------->
                    <!-- Containers-->
                    <!----------------------------->
                    <h6><i>To deactivate a product, set all "Available Quantity" to 0</i></h6>
                    
                    <b-row>
                        <b-col>
                            <table class="table table-bordered" style="background-color:#f2f2f2">
                                <thead class="thead-dark">
                                    <tr>
                                        <th scope="col"><small>Container</small></th>
                                        <th scope="col"><small>Size</small></th>
                                        <th scope="col"><small>Oz per (Can or Bottle)</small></th>
                                        <th scope="col"><small>Available Quantity</small></th>
                                        <th v-if="!isPostOffering" scope="col"><small>Price ($)</small></th>
                                        <th v-else scope="col"><small>Original Price ($)</small></th>
                                        <th style="color:red" v-if="isPostOffering==1" scope="col"><em>Post Offering Price ($)</em></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <!-- Keg 1 -->
                                    <tr>
                                        
                                        <td>Keg 1</td>
                                        <td>
                                            <b-form-select style="width:250px" size="sm" :id="'nested-barrelsize1'+ + theBeer.id" v-model="theBeer.barrel1Size" :options="barrelSizeOptions">
                                                <template v-slot:first>
                                                    <!-- This is required to prevent bugs with Safari -->
                                                    <option disabled value="">Choose Keg 1 size</option>
                                                </template>
                                            </b-form-select>
                                        </td>
                                        <!-- Empty TD for can/case oz -->
                                        <td>NA</td>
                                        <td>
                                            <b-form-input :state="barrel1QtyValid" v-model="theBeer.barrel1Quantity" size="sm"></b-form-input>
                                        </td>
                                        <!-- Allow original price editing if not post offering -->
                                        <td>
                                            <b-form-input v-if="!isPostOffering" :state="barrel1PriceValid" v-model="theBeer.barrel1Cost"  size="sm"></b-form-input>
                                            <div v-else>{{theBeer.origBarrel1Cost}}</div>
                                        </td>
                                        <!-- Price input for post offering -->
                                        <td v-if="isPostOffering==1">
                                            <b-form-input :state="postoffBarrel1PriceValid" v-model="theBeer.postoffBarrel1Cost"  size="sm"></b-form-input>
                                        </td>

                                    </tr>
                                    <!-- Keg 2 -->
                                    <tr>
                                        <td>Keg 2</td>
                                        <td>
                                            <b-form-select style="width:250px"  size="sm" :id="'nested-barrelsize2' + theBeer.id" v-model="theBeer.barrel2Size" :options="barrelSizeOptions">
                                                    <template v-slot:first>
                                                        <!-- This is required to prevent bugs with Safari -->
                                                        <option disabled value="">Choose Keg 2 size</option>
                                                    </template>
                                                </b-form-select>
                                        </td>

                                        <!-- Empty TD for can/case oz -->
                                        <td>NA</td>
                                        <td>
                                            <b-form-input :state="barrel2QtyValid" v-model="theBeer.barrel2Quantity"  size="sm"></b-form-input>
                                        </td>
                                        <td>
                                            <b-form-input v-if="!isPostOffering" :state="barrel2PriceValid"  v-model="theBeer.barrel2Cost"  size="sm"></b-form-input>
                                            <div v-else>{{theBeer.origBarrel2Cost}}</div>
                                        </td>
                                        <!-- Price input for post offering -->
                                        <td v-if="isPostOffering==1">
                                            <b-form-input :state="postoffBarrel2PriceValid" v-model="theBeer.postoffBarrel2Cost"  size="sm"></b-form-input>
                                        </td>

                                    </tr>
                                    <!-- Cans -->
                                    <tr>
                                        <td>Cans</td>
                                        <td>
                                            <b-input-group prepend="Cans per Case" class="" size="sm">
                                                <b-form-input  :state="cansPerCaseValid" v-model="theBeer.cansPerCase"  size="sm"></b-form-input>
                                            </b-input-group>
                                        </td>
                                        
                                        <td>
                                            <b-form-input v-model="theBeer.ozPerCan"  size="sm"></b-form-input>
                                        </td>
                                        <td>
                                            <b-form-input v-model="theBeer.canQuantity" :state="canQtyValid" size="sm"></b-form-input>
                                        </td>
                                        <td>
                                            <b-form-input  v-if="!isPostOffering" v-model="theBeer.canCost" :state="canPriceValid" size="sm"></b-form-input>
                                            <div v-else>{{theBeer.origCanCost}}</div>
                                        </td>
                                        <!-- Price input for post offering -->
                                        <td v-if="isPostOffering==1">
                                            <b-form-input :state="postoffCanPriceValid" v-model="theBeer.postoffCanCost"  size="sm"></b-form-input>
                                        </td>
                                    </tr>

                                    <!-- Bottles -->
                                    <tr>
                                        <td>Bottles</td>
                                        <td>
                                            <b-input-group prepend="Bottles per Case" class="" size="sm">
                                                <b-form-input :state="bottlesPerCaseValid" v-model="theBeer.bottlesPerCase" size="sm" ></b-form-input>
                                            </b-input-group>
                                        </td>
                                        
                                        <td>
                                            <b-form-input v-model="theBeer.ozPerBottle" size="sm" ></b-form-input>
                                        </td>
                                        <td>
                                            <b-form-input :state="bottleQtyValid" v-model="theBeer.bottleQuantity" size="sm" ></b-form-input>
                                        </td>
                                        <td>
                                            <b-form-input  v-if="!isPostOffering" :state="bottlePriceValid" v-model="theBeer.bottleCost"  size="sm"></b-form-input>
                                            <div v-else>{{theBeer.origBottleCost}}</div>
                                        </td>
                                        <!-- Price input for post offering -->
                                        <td v-if="isPostOffering==1">
                                            <b-form-input :state="postoffBottlePriceValid" v-model="theBeer.postoffBottleCost"  size="sm"></b-form-input>
                                        </td>

 
                                    </tr>
                                </tbody>
                            </table>
                            <h6><i>Click update after making any changes</i></h6>
                        </b-col>
                    </b-row>

                                    
                    <!-- End of Multi Size Beer -->

                    <!----------------------------->
                    <!-- Buttons -->
                    <!----------------------------->
                    <b-row>
                        <b-col>
                            <b-button-group>
                                <!-- Update -->
                                <b-button v-if="theBeer.multiSize==1" style='margin-bottom:10px'  class="btn btn-info" @click="updateItemMultiSize(theBeer)">Update</b-button>
                                <!-- Deactivate -->
                                <b-button v-b-modal="'DeactivateBeer' + theBeer.id" style='margin-bottom:10px; margin-left:2px' variant="outline-dark">Deactivate</b-button>
                                    <b-modal :id="'DeactivateBeer' + theBeer.id" title="Deactivate"  ok-title ='Yes, Deactivate' cancel-title ='Do Not Deactivate'  @ok="deactivate(theBeer)">
                                        <p class="my-4">Deactivate {{theBeer.beerName}}?</p>
                                        <p class="my-4">Deactivating will set all available quantities to 0 and buyers will not see it anymore. To reactivate, simpley enter non zero quantities.</p>
                                    </b-modal>

                                <!-- Delete -->
                                <b-button style='margin-bottom:10px; margin-left:2px'  v-b-modal="'DeleteBeer' + theBeer.id" variant="outline-danger">Delete</b-button>
                                    <b-modal :id="'DeleteBeer' + theBeer.id" title="Delete"  ok-title ='Yes, Delete' cancel-title ='Do Not Delete'  @ok="deleteItem(theBeer.id)">
                                        <p class="my-4">Delete {{theBeer.beerName}}?</p>
                                    </b-modal>

                                <!-- Post offering -->
                                <!-- Start a post offering -->
                                <b-button v-if="!isPostOffering"  style='margin-bottom:10px; margin-left:2px' @click="startPostOffering()" class='btn-success'>Start Post Offering</b-button>

                                <!-- When user first clicks start post offering, start and cancel buttons -->
                                <div v-if="isPostOffering&&isNewPostOffering"  style='margin-bottom:10px; margin-left:10px; border: 1px solid grey'>
                                    <b-button style='margin-bottom:10px; margin-left:10px; margin-top:10px' href="#"  class="btn btn-success" @click="updateItemMultiSize(theBeer)">Start Post Offering Now</b-button>
                                    <b-button style='margin-bottom:10px; margin-left:10px; margin-top:10px; margin-right:10px' @click="cancelStartPostOffering()" variant="outline-danger">Cancel</b-button>
                                </div>
                                
                                <!-- Stop a post offering already in progress -->
                                <b-button v-if="isPostOffering&&!isNewPostOffering"  style='margin-bottom:10px; margin-left:10px' @click="showModalStopPostOff()" variant="outline-danger">Stop Post Offering</b-button>
                                    
                            </b-button-group>
                        </b-col>
                    </b-row>
            </b-container>
    </b-container>
</template>

<script>
    import { mapState } from 'vuex'
    import { currentUser } from '../firebaseConfig'
    const fb = require('../firebaseConfig.js')
    import axios from 'axios'
    import Beercomponent from './Beercomponent'
    import { deliveryAgents } from './Myfunctions'
    import Addbeersize from './Addbeersize'
    import {fullBeerStylesList} from './Myfunctions'
    import {mainBeerStylesList} from './Myfunctions'

    export default {
        
        props: ['theOrigBeer'],
        components: {
            Addbeersize,
        },
        computed: {
            ...mapState(['userProfile', 'currentUser', 'isBrewer',  'userInventory', 'promotionsEnabled', 'distributorBreweries', 'distributorBeers', 'allowConsumers']),
            getDeliveryAgents(){
                var deliveryList = deliveryAgents
                return deliveryList
            },
            getImageSource(){

                if(this.theBeer.beerLogoURL) return this.theBeer.beerLogoURL
                else if (this.theBeer.logoFileThumbnailURL) return  this.theBeer.logoFileThumbnailURL
                else return require('../assets/beer.jpg')
            },
            getMainBeerStylesList(){
                return mainBeerStylesList
            },
            getFullBeerStylesList(){
                return fullBeerStylesList()
            },

            //To show the new selected style
            getNewBeerStyle(){
                var styleToReturn = this.theBeer.type
                if (this.otherPressed) styleToReturn= this.theBeer.customType
                return styleToReturn
            },

        },

        data() {
            return {
                theBeer:{},
                updatingItem:false,
                otherDeliveryMethod:'', 
                    cloudinary: {
                        beerimagespreset: 'beerimagespreset',
                        beerimagesthumbnail:'beerimagesthumbnail',
                        apiKey: '629997215451183',
                        cloudName: 'lo4xxr5lr',
                        uploadURL:'https://api.cloudinary.com/v1_1/lo4xxr5lr/image/upload'
                    },
                    selectedFile:'', 
                    fileExtension:'',
                    addingLicense:false,

                    shippingInfoError:false,
                    barrelSizeOptions: [
                    { value: null, text: 'None' },
                    { value: '1/2 Barrel, 15.5 Gal', text: '1/2 Barrel, 15.5 Gal'},
                    { value: '13.2 Gal, 50L', text: '13.2 Gal, 50L'},
                    { value: '1/4th Barrel, 7.75 Gal', text: '1/4th Barrel, 7.75 Gal'},
                    { value: '1/6th Barrel 5.16 Gal', text: '1/6th Barrel, 5.16 Gal'},
                    ],
                    sellToConsumers: false,
                    allowConsumerSales:false,
                    otherPressed:false,
                    uploadingImage:false,

                    //Invalid Input Feedback
                    barrel1QtyValid:true,
                    barrel1PriceValid:true,
                    barrel2QtyValid:true,
                    barrel2PriceValid:true,
                    canQtyValid:true,
                    canPriceValid:true,
                    cansPerCaseValid:true,
                    ozPerCanValid:true,
                    bottleQtyValid:true,
                    bottlePriceValid:true,
                    bottlesPerCaseValid:true,
                    ozPerBottleValid:true,

                    //Post offering
                    isPostOffering:0,
                    isNewPostOffering:0, //When user clicks post offering for the first time
                    postoffBarrel1PriceValid:true,
                    postoffBarrel2PriceValid:true,
                    postoffCanPriceValid:true,
                    postoffBottlePriceValid:true,

                    modalErrMsg:'',

            }
        },

        methods:{

            updateItemMultiSize(thisBeer){
                console.log("Updating")
                var updateBeerDictionary = {}
                var hasError = false

                //Post offering
                updateBeerDictionary.ispostoffering=this.isPostOffering

                //Update sub type
                if(thisBeer.subType) updateBeerDictionary.subType = thisBeer.subType
                updateBeerDictionary.type = thisBeer.type

                //Check if other type was selected
                if(this.otherPressed) updateBeerDictionary.type=this.theBeer.customType

                /**************************/
                /**** Check barrel1 ******/
                /**************************/
                if(thisBeer.barrel1Size||thisBeer.barrel1Cost||thisBeer.barrel1Quantity){
                    //Check for barrel1 cost error
                    if(thisBeer.barrel1Cost<= 0||isNaN(thisBeer.barrel1Cost)){
                        hasError=true
                        this.barrel1PriceValid=false
                    }
                    else this.barrel1PriceValid=true

                    

                    //Check for barrel1 qty error
                    if(thisBeer.barrel1Quantity<0||isNaN(thisBeer.barrel1Quantity)||thisBeer.barrel1Quantity.toString().length===0){
                        hasError=true
                        this.barrel1QtyValid=false
                    }
                    else this.barrel1QtyValid=true

                    if(!thisBeer.barrel1Size||thisBeer.barrel1Cost<= 0||isNaN(thisBeer.barrel1Cost)||thisBeer.barrel1Quantity<0||isNaN(thisBeer.barrel1Quantity )) hasError = true
                    else {

                        updateBeerDictionary.barrel1Size = thisBeer.barrel1Size
                        updateBeerDictionary.barrel1Cost = thisBeer.barrel1Cost
                        updateBeerDictionary.barrel1Quantity = thisBeer.barrel1Quantity
                    }
                }
                /**************************/
                /**** Check barrel2 ******/
                /**************************/
                if(thisBeer.barrel2Size||thisBeer.barrel2Cost||thisBeer.barrel2Quantity){
                    //Check for barrel2 cost error
                    if(thisBeer.barrel2Cost<= 0||isNaN(thisBeer.barrel2Cost)){
                        hasError=true
                        this.barrel2PriceValid=false
                    }
                    else this.barrel2PriceValid=true

                    //Check for barrel2 qty error
                    if(thisBeer.barrel2Quantity<0||isNaN(thisBeer.barrel2Quantity)||thisBeer.barrel2Quantity.toString().length===0 ){
                        hasError=true
                        this.barrel2QtyValid=false
                    }
                    else this.barrel2QtyValid=true

                    if(!thisBeer.barrel2Size||thisBeer.barrel2Cost<= 0||isNaN(thisBeer.barrel2Cost)||thisBeer.barrel2Quantity<0||isNaN(thisBeer.barrel2Quantity )) hasError = true
                    else {
                        updateBeerDictionary.barrel2Size = thisBeer.barrel2Size
                        updateBeerDictionary.barrel2Cost = thisBeer.barrel2Cost
                        updateBeerDictionary.barrel2Quantity = thisBeer.barrel2Quantity
                    }
                }
                /**************************/
                /**** Check cans **********/
                /**************************/
                if(thisBeer.cansPerCase||thisBeer.ozPerCan||thisBeer.canCost||thisBeer.canQuantity){
                    //Check cans per case
                    if(!thisBeer.cansPerCase){
                        hasError=true
                        this.cansPerCaseValid=false
                    }
                    else this.cansPerCaseValid=true

                    //Check can qty
                    if(thisBeer.canQuantity<0||isNaN(thisBeer.canQuantity)||thisBeer.canQuantity.toString().length===0){
                        hasError=true
                        this.canQtyValid=false
                    }
                    else this.canQtyValid=true

                    //Check can cost
                    if(thisBeer.canCost<= 0||isNaN(thisBeer.canCost)){
                        hasError=true
                        this.canPriceValid=false
                    }
                    else this.canPriceValid=true

                    if(!thisBeer.cansPerCase||thisBeer.canCost<= 0||thisBeer.canQuantity<0||isNaN(thisBeer.canQuantity)||isNaN(thisBeer.canCost)) hasError = true
                    
                    else {
                        updateBeerDictionary.cansPerCase = thisBeer.cansPerCase
                        updateBeerDictionary.canCost = thisBeer.canCost
                        updateBeerDictionary.ozPerCan = thisBeer.ozPerCan
                        updateBeerDictionary.canQuantity = thisBeer.canQuantity
                    }
                }
                /**************************/
                /**** Check bottles *******/
                /**************************/
                if(thisBeer.bottlesPerCase||thisBeer.ozPerBottle||thisBeer.bottleCost||thisBeer.bottleQuantity){
                    //Check bottles per case
                    if(!thisBeer.bottlesPerCase){
                        hasError=true
                        this.bottlesPerCaseValid=false
                    }
                    else this.bottlesPerCaseValid=true

                    //Check bottle qty
                    if(thisBeer.bottleQuantity<0||isNaN(thisBeer.bottleQuantity)||thisBeer.bottleQuantity.toString().length===0){
                        hasError=true
                        this.bottleQtyValid=false
                    }
                    else this.bottleQtyValid=true

                    //Check bottle cost
                    if(thisBeer.bottleCost<= 0||isNaN(thisBeer.bottleCost)){
                        hasError=true
                        this.bottlePriceValid=false
                    }
                    else this.bottlePriceValid=true

                    if(!thisBeer.bottlesPerCase||thisBeer.bottleCost<= 0||thisBeer.bottleQuantity<0||isNaN(thisBeer.bottleQuantity)||isNaN(thisBeer.bottleCost)) hasError = true
                    else {
                        updateBeerDictionary.bottlesPerCase = thisBeer.bottlesPerCase
                        updateBeerDictionary.bottleCost = thisBeer.bottleCost
                        updateBeerDictionary.ozPerBottle = thisBeer.ozPerBottle
                        updateBeerDictionary.bottleQuantity = thisBeer.bottleQuantity
                    }
                }

                //Check name
                if(!thisBeer.beerName) hasError = true
                if(hasError){
                    this.$bvModal.show("modal-updateerror"+thisBeer.id)
                    return
                }


                /************************************************************************/
                /***************** Check if post offering *******************************/
                /************************************************************************/
                if(this.isPostOffering){
                    //Check if at least one price has been lowered
                    console.log("IS POST OFFERING")
                    var hasLoweredPrice = false
                    console.log("thisBeer.origBarrel1Cost=" + thisBeer.origBarrel1Cost)
                    console.log("thisBeer.postoffBarrel1Cost=" + thisBeer.postoffBarrel1Cost)
                    if(thisBeer.origBarrel1Cost&&(thisBeer.postoffBarrel1Cost<thisBeer.origBarrel1Cost)) hasLoweredPrice=true
                    if(thisBeer.origBarrel2Cost&&(thisBeer.postoffBarrel2Cost<thisBeer.origBarrel2Cost)) hasLoweredPrice=true
                    if(thisBeer.origCanCost&&(thisBeer.postoffCanCost<thisBeer.origCanCost)) hasLoweredPrice=true
                    if(thisBeer.origBottleCost&&(thisBeer.postoffBottleCost<thisBeer.origBottleCost)) hasLoweredPrice=true

                    console.log("hasLoweredPrice="+hasLoweredPrice) 

                    if(hasLoweredPrice){
                        //Save original prices
                        if(thisBeer.barrel1Cost) updateBeerDictionary.origBarrel1Cost = thisBeer.origBarrel1Cost
                        if(thisBeer.barrel2Cost) updateBeerDictionary.origBarrel2Cost = thisBeer.origBarrel2Cost
                        if(thisBeer.canCost) updateBeerDictionary.origCanCost = thisBeer.origCanCost
                        if(thisBeer.bottleCost) updateBeerDictionary.origBottleCost = thisBeer.origBottleCost

                        //Update new prices
                        if(thisBeer.postoffBarrel1Cost) thisBeer.barrel1Cost=thisBeer.postoffBarrel1Cost
                        if(thisBeer.postoffBarrel2Cost) thisBeer.barrel2Cost=thisBeer.postoffBarrel2Cost
                        if(thisBeer.postoffCanCost) thisBeer.canCost=thisBeer.postoffCanCost
                        if(thisBeer.postoffBottleCost) thisBeer.bottleCost=thisBeer.postoffBottleCost
                    }

                    //Price not lowered, show warning
                    else{
                        this.$bvModal.show("modal-error"+thisBeer.id)
                        this.modalErrMsg="Must reduce price of at least one container"
                        return
                        
                    }
                }
                //End of post offering check
                

                if(thisBeer.barrel1Cost) updateBeerDictionary.barrel1Cost = thisBeer.barrel1Cost
                if(thisBeer.barrel2Cost) updateBeerDictionary.barrel2Cost = thisBeer.barrel2Cost
                if(thisBeer.barrel1Quantity) updateBeerDictionary.barrel1Quantity = parseInt(thisBeer.barrel1Quantity)
                if(thisBeer.barrel2Quantity) updateBeerDictionary.barrel2Quantity = parseInt(thisBeer.barrel2Quantity)
                if(thisBeer.canCost) updateBeerDictionary.canCost = thisBeer.canCost
                if(thisBeer.canQuantity) updateBeerDictionary.canQuantity = parseInt(thisBeer.canQuantity)
                if(thisBeer.bottleCost) updateBeerDictionary.bottleCost = thisBeer.bottleCost
                if(thisBeer.bottleQuantity) updateBeerDictionary.bottleQuantity = parseInt(thisBeer.bottleQuantity)
                if(thisBeer.abv) updateBeerDictionary.abv = thisBeer.abv
                if(thisBeer.description) updateBeerDictionary.description = thisBeer.description
                if(thisBeer.beerName) updateBeerDictionary.beerName = thisBeer.beerName
                if(thisBeer.deliveryMethod) updateBeerDictionary.deliveryMethod = thisBeer.deliveryMethod


                updateBeerDictionary.allowConsumers=0

                this.updatingItem = true

                var fbref = fb.beersCollection
                var idRef = ''
                var deliveryMethod = ''
                if (this.userProfile.isbrewer==1||this.userProfile.isbrewer==10){
                    //fbref=fb.beersCollection
                    idRef = 'uid'
                } 
                if (this.userProfile.isbrewer==2){
                    //fbref=fb.distributorBeersCollection
                    deliveryMethod = this.userProfile.company
                    idRef = 'distributorId'
                }
                else if (thisBeer.deliveryMethod) deliveryMethod = thisBeer.deliveryMethod

                //Set county
                updateBeerDictionary.county=this.userProfile.county
                updateBeerDictionary.counties = this.userProfile.counties

                //Revert other pressed
                this.otherPressed=false

                var idToFind=this.currentUser.uid
                //Use distributorid if user is a rep
                if(this.userProfile.isbrewer==10) idToFind=this.userProfile.distributorid
                console.log('Beer id: '+ thisBeer.id)
                console.log('uid: '+ idToFind)

                fbref.where('id', '==', thisBeer.id).where(idRef, '==', idToFind).get().then(docs => {
                    docs.forEach(doc => {
                        console.log("Updating beer doc Id: " + doc.id)
                        fbref.doc(doc.id).update(updateBeerDictionary)
                        this.updatingItem = false
                        this.$bvToast.toast(updateBeerDictionary.beerName + ' Updated', {
                        title: 'Inventory Update',
                        solid:true,
                        variant: 'success',
                        autoHideDelay: 3000,
                        appendToast: false
                        })
                        this.isNewPostOffering=0

                    })
                    }).catch(err => {
                    console.log(err)
                    })

            },

            addContainer(thisBeer){
                console.log("Showing add size Modal")
            },

            deleteItem(beerId){
                console.log("Deleting id "+ beerId)
                var delete_query = fb.beersCollection.where('id','==',beerId);
                delete_query.get().then(function(querySnapshot) {
                    querySnapshot.forEach(function(doc) {
                    doc.ref.delete();
                    });
                });
            },

            promoteBeer(beerData){
                var promotedDate = new Date()
                var promotedTime = promotedDate.getTime()
                //Promote for 30 days
                var expiresOn = promotedTime+(60*60*24*30*1000)
                beerData.promotedDate = promotedDate
                beerData.promotedTime  = promotedTime
                beerData.promotionExpiresOn = expiresOn
                //Add to promoted beers collection

                //Update master beers collection to show promoted
                fb.beersCollection.where('id', '==', beerData.id).where('uid', '==', this.currentUser.uid).get().then(docs => {
                    docs.forEach(doc => {
                        fb.beersCollection.doc(doc.id).update({
                            promotedTime: promotedTime,
                            promotionExpiresOn: expiresOn,
                        })

                    })
                    }).catch(err => {
                    console.log(err)
                    })
                
                this.$bvModal.show("modal-inventoryupdated" + this.theBeer.id)
                this.$bvToast.toast(beerData.beerName + ' has been promoted', {
                        title: 'Beer promoted',
                        solid:true,
                        variant: 'success',
                        autoHideDelay: 5000,
                        appendToast: false
                        })
            },
            
            stopPromotion(beerData){
                //Update master beers collection to end promotion
                fb.beersCollection.where('id', '==', beerData.id).where('uid', '==', this.currentUser.uid).get().then(docs => {
                    docs.forEach(doc => {
                        fb.beersCollection.doc(doc.id).update({
                            promotionExpiresOn: 0,
                        })

                    })
                    }).catch(err => {
                    console.log(err)
                    })
                this.$bvToast.toast(beerData.beerName + ' promotion ended', {
                        title: 'Beer promotion has been ended',
                        solid:true,
                        variant: 'success',
                        autoHideDelay: 5000,
                        appendToast: false
                        })
            },
            onLogoFileChanged (event) {
                
                if (!event || !event.target || !event.target.files || event.target.files.length === 0) {
                    return;
                }
                this.selectedFile = event.target.files[0]
        
                const name = event.target.files[0].name;
                const lastDot = name.lastIndexOf('.');

                const fileName = name.substring(0, lastDot);
                const ext = name.substring(lastDot + 1);

                //outputfile.value = fileName;
                this.fileExtension = ext;
                this.uploadLogotoCloudinary()

            },
            uploadLogotoCloudinary(){
                //this.addingLicense = true
                this.uploadingImage = true
                let data = new FormData();
                data.append('file', this.selectedFile); 
                data.append('upload_preset', this.cloudinary.beerimagesthumbnail);

                axios
                    .post(this.cloudinary.uploadURL, data)
                    .then((result) => {
                        console.log("URL = " + result.data.secure_url)
                        if(result.data.secure_url){
                            fb.beersCollection.doc(this.theBeer.docId).update({
                            beerLogoURL:result.data.secure_url
                        })
                        }
                        this.uploadingImage = false

                    })
                    .catch((err) => {
                        console.log('Ax Error:' + err);
                        this.uploadingImage = false
                    }) 

                let thumbdata = new FormData();
                thumbdata.append('file', this.selectedFile); 
                thumbdata.append('upload_preset', this.cloudinary.beerimagesthumbnail);

                //Add thumbnail
                axios
                    .post(this.cloudinary.uploadURL, thumbdata)
                    .then((result) => {
                        if(result.data.secure_url){
                            fb.beersCollection.doc(this.theBeer.docId).update({
                            logoUploaded:1,
                            logoFileThumbnailURL:result.data.secure_url
                        })
                        }
                        this.$bvToast.toast("Beer image updated", {
                            title: 'Beer Added!',
                            solid:true,
                            variant: 'success',
                            autoHideDelay: 5000,
                            appendToast: false
                        })
                        this.uploadingImage = false
                    })
                    .catch((err) => {
                        console.log('Ax Thumb Error:' + err);
                        this.uploadingImage = false
                    })

            },

            //Check for errors in consumer delivery
            checkConsumerErrors(){
                var hasError = false;
                if(!this.userProfile.consumerDeliveryFees){
                    hasError = true
                    console.log("consumerDeliveryFees")
                } 
                if (!this.userProfile.consumerDeliveryTime) {
                    hasError = true
                    console.log("consumerDeliveryTime")
                } 
                if(!this.userProfile.consumerShippingTime) {
                    hasError = true
                    console.log("consumerShippingTime")
                } 
                if(!this.userProfile.minForFreeDelivery) {
                    hasError = true
                    console.log("consumerFreeDelivery")
                } 

                if(hasError){
                    this.$bvModal.show("modal-errorshipping" + this.theBeer.id)
                }
                return hasError
            },

            //Update beer type
            setDrinkType(type){
                this.otherPressed=false
                this.theBeer.type=type
                console.log("New type = " + this.theBeer.type)
                //this.$bvModal.hide("showStylesList" + this.theBeer.id)
            },
            //Update other beer type
            setOtherDrinkType(){
                console.log("Selecting other")
                this.otherPressed=true
                //this.$bvModal.hide("showStylesList" + this.theBeer.id)
            },
            beerTypeHasBeenSelected(){
                this.$bvModal.hide("showStylesList" + this.theBeer.id)
            },

            //Post offering
            startPostOffering(){
                
                //Set post offering
                this.isPostOffering=1
                if(!(this.theBeer.ispostoffering==1)) this.isNewPostOffering=1
                else this.isNewPostOffering=0

                //Copy original prices to post offering prices
                if(this.theBeer.barrel1Cost) this.theBeer.postoffBarrel1Cost = this.theBeer.barrel1Cost
                if(this.theBeer.barrel2Cost) this.theBeer.postoffBarrel2Cost = this.theBeer.barrel2Cost
                if(this.theBeer.canCost) this.theBeer.postoffCanCost = this.theBeer.canCost
                if(this.theBeer.bottleCost) this.theBeer.postoffBottleCost = this.theBeer.bottleCost

                //Copy to original costs
                if(this.theBeer.barrel1Cost) this.theBeer.origBarrel1Cost = this.theBeer.barrel1Cost
                if(this.theBeer.barrel2Cost) this.theBeer.origBarrel2Cost = this.theBeer.barrel2Cost
                if(this.theBeer.canCost) this.theBeer.origCanCost = this.theBeer.canCost
                if(this.theBeer.bottleCost) this.theBeer.origBottleCost = this.theBeer.bottleCost
            },
            
            //Show modal to stop post offering
            showModalStopPostOff(){
                this.$bvModal.show("modal-confirmstoppostoff"+this.theBeer.id)

            },

            //Stop post offering
            stopThePostOffering(){
                if(this.theBeer.origBarrel1Cost) this.theBeer.barrel1Cost = this.theBeer.origBarrel1Cost
                if(this.theBeer.origBarrel2Cost) this.theBeer.barrel2Cost = this.theBeer.origBarrel2Cost
                if(this.theBeer.origCanCost) this.theBeer.canCost = this.theBeer.origCanCost
                if(this.theBeer.origBottleCost) this.theBeer.bottleCost = this.theBeer.origCanCost
                this.isPostOffering=0
                this.isNewPostOffering=0
                this.theBeer.ispostoffering=0
                this.updateItemMultiSize(this.theBeer)

            },
            
            //User cancelled start of post offering
            cancelStartPostOffering(){
                this.isPostOffering=0
                this.isNewPostOffering=0

            },

            //Deactivate a beer
            deactivate(beerToDeactivate){
                this.theBeer.barrel1Quantity=0
                this.theBeer.barrel2Quantity=0
                this.theBeer.canQuantity=0
                this.theBeer.bottleQuantity=0
                this.updateItemMultiSize(this.theBeer)

            }
        },
        mounted(){
            //Copy beer to local object
            this.theBeer = JSON.parse(JSON.stringify(this.theOrigBeer));

            //Check if beer on post offering
            if(this.theBeer.ispostoffering){
                this.isPostOffering=this.theBeer.ispostoffering
                //Copy original prices to post offering prices
                if(this.theBeer.barrel1Cost) this.theBeer.postoffBarrel1Cost = this.theBeer.barrel1Cost
                if(this.theBeer.barrel2Cost) this.theBeer.postoffBarrel2Cost = this.theBeer.barrel2Cost
                if(this.theBeer.canCost) this.theBeer.postoffCanCost = this.theBeer.canCost
                if(this.theBeer.bottleCost) this.theBeer.postoffBottleCost = this.theBeer.bottleCost
                console.log("this.theBeer.postoffBarrel1Cost="+this.theBeer.postoffBarrel1Cost)
                console.log("this.theBeer.barrel1Cost="+this.theBeer.barrel1Cost)

            }
            else this.isPostOffering=0
        },
        
    }
</script>

<style scoped>
    .errorclass{
        color:red;
    }
</style>